import React, { useEffect } from "react";
import { useHistory } from "react-router-dom";
import { IoConstruct, IoFlash, IoPlayForward, IoStatsChart, IoVideocam } from "react-icons/io5";
import { useToggleTop } from "../../common/ToggleTop";
import { REMOTE_PATHS } from "../../../pages/Remote/remoteUtils";
import { CAMERA_PATHS } from "../../../pages/Camera/paths";

// The app's "+" actions (app/screens/ActionButtonModal.js), which dropped the
// Rule Engine for Automations, plus Cameras: with Automation on, the Camera
// tab gives way to it. An action with a path has a web page; the others show
// "Soon".
const ACTIONS = [
  { title: "Real Time Monitoring", icon: IoFlash },
  { title: "Power Control", icon: IoConstruct },
  { title: "Statistics", icon: IoStatsChart },
  { title: "Universal Remotes", icon: IoPlayForward, path: REMOTE_PATHS.UNIVERSAL },
  { title: "Cameras", icon: IoVideocam, path: CAMERA_PATHS.LIST },
];

const ActionMenu = ({ open, onClose }) => {
  const history = useHistory();
  const toast = useToggleTop();

  useEffect(() => {
    if (!open) return undefined;
    const onKey = (event) => event.key === "Escape" && onClose();
    document.addEventListener("keydown", onKey);
    return () => document.removeEventListener("keydown", onKey);
  }, [open, onClose]);

  if (!open) return null;

  const run = (action) => {
    if (action.path) {
      onClose();
      history.push(action.path);
    } else {
      toast(`${action.title} is coming to the web dashboard soon`, "blue");
    }
  };

  return (
    <div id="hx-actions" className="hx-actions" onClick={onClose}>
      <ul className="hx-actions-list" onClick={(event) => event.stopPropagation()}>
        {ACTIONS.map((action, index) => {
          const Icon = action.icon;
          return (
            <li key={action.title} style={{ "--i": index }}>
              <button type="button" className="hx-action" onClick={() => run(action)}>
                <span className="hx-action-label">
                  {action.title}
                  {action.path ? null : <span className="hx-soon">Soon</span>}
                </span>
                <span className="hx-action-icon" aria-hidden="true">
                  <Icon />
                </span>
              </button>
            </li>
          );
        })}
      </ul>
    </div>
  );
};

export default ActionMenu;
